<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        const query = await stuff.cms.advertise();
        return {
            props: {
                query,
            },
        };
    };
</script>

<script lang="ts">
    import type { AdvertiseQuery } from '$gen/graphql';
    import SeoMetaTags from '$lib/components/SeoMetaTags.svelte';

    export let query: AdvertiseQuery;

    $: content = query?.entry?.__typename === 'advertise_advertise_Entry' ? query.entry : null;
</script>

{#if content}
    <SeoMetaTags seo={content?.seo} />

    <article class="grid h-full min-h-screen place-items-center bg-pink">
        {#each content.advertisePdf as pdf}
            <a
                class="group relative cursor-pointer overflow-visible whitespace-nowrap text-xl sm:text-4xl lg:text-5xl xl:text-7xl"
                href={pdf.url}
                target="_blank"
            >
                <div
                    class="rounded-full bg-green px-8 py-2 text-transparent opacity-100 blur-sm transition-opacity group-hover:opacity-0 md:px-16 xl:blur-md"
                >
                    {content?.label}
                </div>
                <div
                    class="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-24 py-10"
                >
                    <span class="text-white">{content?.label}</span>
                </div>
            </a>
        {/each}
    </article>
{/if}

<style lang="scss">
    article {
        grid-column: full !important;
    }

    .common-styles {
        @apply px-16 py-2;
    }

    // .blur-green {
    //     &::after {
    //         position: absolute;
    //         transition: background-color 0.2s, opacity 0.2s;
    //         z-index: -1;
    //         content: '';
    //         top: 0;
    //         left: 0;
    //         right: 0;
    //         bottom: 0;
    //         filter: blur(0.11em);
    //         border-radius: 999999px;
    //         pointer-events: none;
    //         background-color: theme('colors.green');
    //     }
    //     &:hover::after {
    //         opacity: 0;
    //     }
    // }
</style>
